<template lang="pug">
pr-wrapper#platform(fs, zi="3")
  pr-badge.numpad.py-2.px-3(reverse, v-show="$numpad.value", size="medium") {{ $numpad.value }}
  keep-alive(v-if="router")
    router-view.router-view
</template>

<script>
import { mapState } from "vuex"

export default {
  name: "platform",
  computed: {
    ...mapState(["router"])
  }
}
</script>

<style lang="scss" scoped>
#platform {
  .numpad {
    z-index: 3;
    position: absolute;
    top: 15px;
    right: 15px;
  }

  display: flex;

  .router-view {
    z-index: 2;
  }
}
</style>
